import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummaryComponent } from './summary/summary.component';
import { AxGridModule, AxChartModule, AxParcoordsModule } from 'src/app/shared/components';
import { SummaryService } from './summary/summary.service';
import { DetailService } from './detail/detail.service';
import { ParcoordsService } from './parcoords/parcoords.service';
import { ParcoordsComponent } from './parcoords/parcoords.component';
import { DxButtonModule, DxPopupModule, DxListModule, DxMultiViewModule, DxSortableModule, DxTabPanelModule } from 'devextreme-angular';
import { FactorComponent } from './factor/factor.component';
import { FactorService } from './factor/factor.service';
import { CategoryComponent } from './factor/category/category.component';
import { CurrencyComponent } from './factor/currency/currency.component';
import { HistoryTabComponent } from './factor/history-tab/history-tab.component';
import { NameComponent } from './factor/name/name.component';
import { SecurityComponent } from './factor/security/security.component';
import { SecurityDetailComponent } from './factor/security-detail/security-detail.component';
import { HistoryTabDirective } from './factor/history-tab/history-tab.directive';
import { AxDrillDownBarpModule } from 'src/app/shared/components/drill-down-bar/drill-down-bar.component';
import { HistoryTabService } from './factor/history-tab/history-tab.service';

@NgModule({
  declarations: [
    SummaryComponent, /*
    DetailComponent, */
    ParcoordsComponent,
    FactorComponent,
    CategoryComponent,
    CurrencyComponent,
    HistoryTabComponent,
    NameComponent,
    SecurityComponent,
    SecurityDetailComponent,
    HistoryTabDirective
  ],
  imports: [
    CommonModule,
    AxGridModule,
    //AxTreeMapModule,
    AxChartModule,
    AxParcoordsModule,
    DxButtonModule,
    DxPopupModule,
    DxListModule,
    DxMultiViewModule,
    AxDrillDownBarpModule,
    DxSortableModule,
    DxTabPanelModule
  ],
  providers: [
    SummaryService,
    DetailService,
    ParcoordsService,
    FactorService,
    HistoryTabService
  ]
})
export class GfrModule { }
